import axios from "axios";
import { toast } from "react-toastify";
import {
  CREATE_COACHING_PERFORMANCE,
  DELETE_COACHING_PERFORMANCE,
  GET_ALL_COACHING_PERFORMANCE,
  GET_STUDENT_COACHING_PERFORMANCE,
  GET_COACHING_PERFORMANCE,
  GET_COACHING_PERFORMANCE_BATCH,
  UPDATE_COACHING_PERFORMANCE,
} from "../constants/Type";
import { BASE_URL } from "../constants/URL";

//GET ALL COACHING PERFORMANCE RESULT
export const getAllCoachingPerformance =
  (batchId, year, term, gradeId, shiftId) => async (dispatch) => {
    const data = {
      batchId,
      year,
      term,
      gradeId,
      shiftId,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.post(
        `${BASE_URL}/api/coaching-performance/all`,
        JSON.stringify(data),
        config
      );

      dispatch({
        type: GET_ALL_COACHING_PERFORMANCE,
        payload: { ...res.data },
      });
      return res.data.data;
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

//GET COACHING PERFORMANCE RESULT FOR STUDENT INTERVAL
export const getCoachingPerformanceResult =
  (startTerm, startYear, endTerm, endYear, studentId, year, gradeId, shiftId, batchId) =>
  async (dispatch) => {
    const data = {
      startTerm,
      startYear,
      endTerm,
      endYear,
      year,
      gradeId,
      shiftId,
      batchId,
      studentId,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.post(
        `${BASE_URL}/api/coaching-performance/between`,
        JSON.stringify(data),
        config
      );

      dispatch({
        type: GET_COACHING_PERFORMANCE,
        payload: { ...res.data },
      });
      return res.data.data;
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

//GET STUDENT LIST FOR COACHING PERFORMANCE (students without entries)
export const getCoachingPerformanceStudentForBatch =
  (year, term, batchId, termCount) => async (dispatch) => {
    const data = {
      year,
      term,
      batchId,
      termCount,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.post(
        `${BASE_URL}/api/coaching-performance/batch`,
        JSON.stringify(data),
        config
      );

      dispatch({
        type: GET_STUDENT_COACHING_PERFORMANCE,
        payload: { ...res.data },
      });
      return res.data.data;
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

//GET BATCH STUDENTS WITH COACHING PERFORMANCE
export const getBatchCoachingPerformanceResult =
  (year, term, batchId) => async (dispatch) => {
    const data = {
      year,
      term,
      batchId,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.post(
        `${BASE_URL}/api/coaching-performance/batch-res`,
        JSON.stringify(data),
        config
      );

      dispatch({
        type: GET_COACHING_PERFORMANCE_BATCH,
        payload: { ...res.data },
      });
      return res.data.data;
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

// CREATE COACHING PERFORMANCE
export const createCoachingPerformance = (term, year, marks) => async (dispatch) => {
  let data = {
    term: parseInt(term),
    marks,
    year: parseInt(year),
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.post(
      `${BASE_URL}/api/coaching-performance`,
      JSON.stringify(data),
      config
    );
    dispatch({
      type: CREATE_COACHING_PERFORMANCE,
    });
    toast.success("Coaching performance added successfully");

    return true;
  } catch (err) {
    toast.error(err.response.data.message);
    return false;
  }
};

// EDIT COACHING PERFORMANCE
export const editCoachingPerformance = (term, year, marks) => async (dispatch) => {
  let data = {
    term: parseInt(term),
    marks,
    year: parseInt(year),
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.patch(
      `${BASE_URL}/api/coaching-performance`,
      JSON.stringify(data),
      config
    );
    dispatch({
      type: UPDATE_COACHING_PERFORMANCE,
    });
    toast.success("Coaching performance edited successfully");

    return true;
  } catch (err) {
    toast.error(err.response.data.message);
    return false;
  }
};

// DELETE COACHING PERFORMANCE
export const deleteCoachingPerformance = (id) => async (dispatch) => {
  try {
    await axios.delete(`${BASE_URL}/api/coaching-performance/${id}`);
    dispatch({
      type: DELETE_COACHING_PERFORMANCE,
      payload: id,
    });
    toast.success("Coaching performance deleted successfully");
    return true;
  } catch (err) {
    toast.error(err.response?.data?.message || "Something went wrong");
    return false;
  }
};
